import { OdataManager } from '@/api/odata/odata-manager';
import { RegisterIssue } from '@/api/model/interfaces';

export default class RegisterIssueOdata extends OdataManager<RegisterIssue> {}
